/**
 * Generates a public-facing property display name from internal property fields.
 *
 * Mirrors the backend `build_display_name(prop)` helper in `server.py`.
 * Used as a self-healing fallback when `property.display_name` is missing
 * (e.g., legacy data on a DB that hasn't run the migration yet).
 *
 * Format: "{N}-Bedroom [Pool ]{Type} in {Location}"
 *   - "Land" properties => "Land in {Location}"
 *   - 0 bedrooms => "Studio [Pool ]{Type} in {Location}"
 *   - "private_pool" amenity inserts "Pool " modifier
 */
export const buildDisplayName = (property) => {
  if (!property) return 'Bali Villa';
  if (property.display_name) return property.display_name;

  const bedrooms = property.bedrooms || 0;
  const location = property.location || 'Bali';
  const ptypeRaw = (property.property_type || 'villa').toLowerCase();
  const amenities = property.amenities || [];

  const typeLabels = {
    villa: 'Villa',
    apartment: 'Apartment',
    house: 'House',
    commercial: 'Commercial Space',
    land: 'Land',
    townhouse: 'Townhouse',
    boutique_hotel: 'Boutique Hotel',
  };
  const typeLabel = typeLabels[ptypeRaw] || ptypeRaw.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
  const poolPrefix = amenities.includes('private_pool') ? 'Pool ' : '';

  if (ptypeRaw === 'land') return `Land in ${location}`;
  if (bedrooms <= 0) return `Studio ${poolPrefix}${typeLabel} in ${location}`.replace('  ', ' ').trim();
  return `${bedrooms}-Bedroom ${poolPrefix}${typeLabel} in ${location}`;
};
